module.exports = __webpack_public_path__ + "components/page-header/static/icon-heart-white-3fdf9c7e50138236bbaad109e4ae5883.svg";